import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';

import {
  Card,
  ImageWrapper,
  Img,
  Body,
  SmallCopy,
  TextWrapper,
  LegalCopy,
  StyledCtas,
} from './styles';

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <SmallCopy>{children}</SmallCopy>,
  },
};

const legal = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <LegalCopy>{children}</LegalCopy>,
  },
};

const Product = ({ data = null, className = '' }) => {
  if (!data) return null;

  const {
    id,
    textAlignment,
    heading,
    bodyCopy,
    bottomCopy,
    ctas,
    backgroundColor,
    imageDam,
    component,
  } = data;

  return className === 'columns-2' ? (
    <Card
      key={id}
      className={`${className} ${component}`}
      role="listitem"
      $backgroundColor={backgroundColor}
    >
      {imageDam && (
        <ImageWrapper>
          <Img src={imageDam} alt={imageDam.altText || ''} />
        </ImageWrapper>
      )}
      <Body>
        {(heading || bodyCopy || bottomCopy) && (
          <TextWrapper
            className={`${className} ${textAlignment || 'left'}`}
            $textAlignment={textAlignment}
            $backgroundColor={backgroundColor}
          >
            {heading && <RichText document={heading} />}
            {bodyCopy && <RichText document={bodyCopy} options={body} />}
            {bottomCopy && <RichText document={bottomCopy} options={legal} />}
          </TextWrapper>
        )}

        {ctas && (
          <StyledCtas
            ctas={ctas}
            position="center-center-left"
            direction="row"
          />
        )}
      </Body>
    </Card>
  ) : (
    <Card key={id} className={className} role="listitem">
      {imageDam && (
        <ImageWrapper>
          <Img src={imageDam} alt={imageDam.altText || ''} />
        </ImageWrapper>
      )}
      <Body>
        <TextWrapper
          className={`${className} ${textAlignment || 'left'} `}
          $textAlignment={textAlignment}
          $backgroundColor={backgroundColor}
        >
          {heading && <RichText document={heading} />}
          {bodyCopy && <RichText document={bodyCopy} options={body} />}
          {bottomCopy && <RichText document={bottomCopy} options={legal} />}
        </TextWrapper>
      </Body>
      {ctas && (
        <StyledCtas
          ctas={ctas}
          position="center-center-left"
          direction="column"
        />
      )}
    </Card>
  );
};

Product.propTypes = {
  data: PropTypes.shape(),
  className: PropTypes.string,
};

export default Product;
